import { viewer } from "./viewerStore";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VID_KEY = "nbs_vid";

const visitorId = () => {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
      v = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9_-]/g, "");
      localStorage.setItem(VID_KEY, v);
    }
    return v;
  } catch {
    return null;
  }
};

/* Fire-and-forget activity ping for the private stats page. Never throws, never blocks. */
export const track = (type) => {
  try {
    if (navigator.webdriver) return;
    const vid = visitorId();
    if (!vid) return;
    const payload = { vid, type, ...(viewer.email ? { email: viewer.email } : {}) };
    const body = new Blob([JSON.stringify(payload)], { type: "application/json" });
    if (!navigator.sendBeacon?.(`${API}/events`, body)) {
      fetch(`${API}/events`, { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
    }
  } catch {
    /* tracking must never affect the visitor */
  }
};
